export interface UtmParams {
  source?: string;    // utm_source (e.g. "tiktok", "instagram", "google")
  medium?: string;    // utm_medium (e.g. "social", "cpc", "email")
  campaign?: string;  // utm_campaign (e.g. "summer_sale")
  content?: string;   // utm_content (e.g. "video_123")
  term?: string;      // utm_term (keyword for paid search)
}

/**
 * Extract UTM parameters from a URL query string (defaults to the current URL).
 * Returns null when no utm_* params are present.
 *
 * The SDK only CAPTURES here — it no longer classifies. Traffic-source
 * interpretation (referrer → source/medium, paid vs organic, click IDs) lives
 * server-side now: the SDK forwards the raw referrer + landing URL and the
 * server decides what they mean. Keeping that logic off the client keeps the
 * bundle small and lets new networks / rule fixes ship without a new SDK.
 */
export function extractUtmParams(search?: string): UtmParams | null {
  const query =
    search ?? (typeof window !== 'undefined' ? window.location.search : '');
  if (!query) return null;

  const params = new URLSearchParams(query);

  const source = params.get('utm_source') ?? undefined;
  const medium = params.get('utm_medium') ?? undefined;
  const campaign = params.get('utm_campaign') ?? undefined;
  const content = params.get('utm_content') ?? undefined;
  const term = params.get('utm_term') ?? undefined;

  if (source || medium || campaign || content || term) {
    return {
      ...(source && { source }),
      ...(medium && { medium }),
      ...(campaign && { campaign }),
      ...(content && { content }),
      ...(term && { term }),
    };
  }

  return null;
}
